import React from 'react';
import { motion } from 'framer-motion';
import type { TransformationItem } from '../../types/salesPage';
interface TransformationBandProps {
  items: TransformationItem[];
}
export function TransformationBand({
  items
}: TransformationBandProps) {
  return <section aria-labelledby="transformation-title" className="border-t border-white/[0.07] bg-carbon px-5 py-14 sm:px-6 md:py-20" data-id="element-318" data-mp="1t3d9obwgvn9p">
      <div className="mx-auto max-w-5xl" data-id="element-319" data-mp="2lpo93j8c7i4x">
        <header className="text-center" data-id="element-320" data-mp="2ls0wwd0s0mpw">
          <h2 id="transformation-title" className="font-serif text-[24px] font-semibold italic leading-tight text-ivory sm:text-[30px] md:text-[36px]" data-id="element-321" data-mp="2qpiux8d99hj4">
            La vida del otro lado de los 30 días
          </h2>
        </header>

        <ul className="mt-10 grid gap-4 sm:grid-cols-3 sm:gap-5" data-id="element-322" data-mp="2gwv2sqx801qq">
          {items.map((item, i) => <motion.li key={item.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08,
          ease: 'easeOut'
        }} className="overflow-hidden rounded-sm border border-white/10 bg-panel" data-id="element-323" data-mp="39fihnolmikjd" data-mpi={i}>
              <img src={item.image.src} alt={item.image.alt} loading="lazy" decoding="async" className="h-40 w-full object-cover sm:h-44" data-id="element-324" data-mp="xjnhl1intspz" />
              <div className="px-5 pb-5 pt-4" data-id="element-325" data-mp="12h5gdz2yqrk9">
                <h3 className="font-serif text-[17px] font-semibold text-ivory" data-id="element-326" data-mp="12gdvpjawme8r">{item.title}</h3>
                <p className="mt-2 text-[13.5px] font-light leading-relaxed text-ash" data-id="element-327" data-mp="1gfvg7mh635cb">
                  {item.text}
                </p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}